export default {
  baseErrorMessges: {
    required: "This field is required.",
    dataType: "This field is not of the correct type.",
    existingAsset: "An asset with this identifier already exists.",
    serialNoIsReq: "Serial number is required.",
    length: "This fields value must be",
    maxLength: "The maximum number of available characters for this field has been exceeded!",
    min: "min",
    max: "max",
    onlyNumbersOptionalCommaOrDot:
      "Please note the desired format. Only numbers and decimal points are allowed in this field (it should be rounded to two decimal places by default)!",
    onlyIntegers: "Please specify the desired format. Only whole numbers are allowed in this field!",
    lettersNumbersOnly:
      "Please specify the desired format. Only numbers, letters, and special characters are allowed in this field!",
    guid: "Please adjust the desired format for the GUID. Allowed are numbers, letters a-f, and hyphens as in this example: 51d52cf1-83c9-4f02-b117-703ecb728b74",
  },
};
